/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type {
  Axis,
  AxisSetExtremesEventObject,
  Options,
  SeriesOptionsType,
} from 'highcharts/highstock';
import type { MutableRefObject } from 'react';
import { PumpRuntimeChartRootProps } from './pumpRuntime-chart.components';

/**
 * THIS FILE CAN BE IMPROVED BY:
 * - REMOVING DUPLICATED OPTIONS BETWEEN STACK AND OVERLAY MODE
 */

export type EventHandlers =
  | (PumpRuntimeChartRootProps['events'] & {
      onSynchronizedExtremesChange?: (
        this: Axis,
        e: AxisSetExtremesEventObject
      ) => void;
    })
  | undefined;

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * PumpRuntime Mode Options
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const makeRuntimeOptions = (
  eventHandlers: MutableRefObject<EventHandlers>
): Options => {
  return {
    chart: {
      type: 'column',
      events:{
        redraw: function(){
          // @ts-ignore
          if(!this.series || !window.Cypress) return;
          this.series.forEach((eachSeries) => {
            // @ts-ignore
            if(!eachSeries.dataMax || !eachSeries.group) return;
            // @ts-ignore
            eachSeries.group.element.setAttribute('className', `barValue_${eachSeries.dataMax}`);
          });
        }
      }
    },
    credits: { enabled: false },
    legend: { enabled: true },
    rangeSelector: { enabled: false },
    navigator: { enabled: false },
    scrollbar: { enabled: false },
    exporting: { enabled: false },
    yAxis: { opposite: false },
    plotOptions: {
      column: {
        pointWidth: undefined,
        grouping: false,
      },
      series: {
        showInLegend: true,
        states: {
          hover: {
            lineWidth: undefined,
            lineWidthPlus: 0,
          },
          inactive: { opacity: 1 },
        },
        events: {
          hide: function (event) {
            // TODO: Check this error
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const target = event.target as SeriesOptionsType | null;
            if (
              target &&
              'baseSeries' in target &&
              target.baseSeries === undefined
            ) {
              eventHandlers.current?.series?.onVisibilityChange?.(
                target.index!,
                event.type as 'hide' | 'show'
              );
            }
          },
          show: function (event) {
            // TODO: Check this error
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const target = event.target as SeriesOptionsType | null;
            if (
              target &&
              'baseSeries' in target &&
              target.baseSeries === undefined
            ) {
              eventHandlers.current?.series?.onVisibilityChange?.(
                target.index!,
                event.type as 'hide' | 'show'
              );
            }
          },
        },
      },
    },
  };
};
